import ReactDOM from "react-dom/client"
import App from "./App"
import "./global.css"
import { Toaster } from "sonner"

ReactDOM.createRoot(document.getElementById("root")).render(
  <>
    <App />
    <Toaster position="top-center" richColors duration={1200} />
  </>
)
